type FirebaseWebClientConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
  vapidKey: string;
};

/**
 * Firebase Web SDK config + VAPID из переменных окружения `EXPO_PUBLIC_*`.
 *
 * <p>Раньше значения приходили импортом из `@env` (плагин `react-native-dotenv`). Плагин убран:
 * он подменял НЕ только `@env`, а вообще любое обращение `process.env.X` значением с машины,
 * где шла сборка. Metro распараллеливает трансформации через `jest-worker`, тот выставляет в
 * воркерах `JEST_WORKER_ID=1` — и в бандл уезжала константа `IS_JEST = true`. Reanimated по ней
 * переключался на веб-реализацию shared values прямо на телефоне, и приложение падало при
 * первом же маппере. Заодно это был канал утечки: любая переменная окружения сборщика,
 * упомянутая где-нибудь как `process.env.X`, зашивалась в бандл.
 *
 * <p>`EXPO_PUBLIC_*` подставляет сам `babel-preset-expo` (и EAS передаёт их из профиля), а для
 * веба те же имена перечислены в `DefinePlugin` в `webpack.config.cjs`.
 */
export function getFirebaseWebConfig(): FirebaseWebClientConfig | null {
  const apiKey = process.env.EXPO_PUBLIC_FIREBASE_WEB_API_KEY ?? '';
  const authDomain = process.env.EXPO_PUBLIC_FIREBASE_WEB_AUTH_DOMAIN ?? '';
  const projectId = process.env.EXPO_PUBLIC_FIREBASE_WEB_PROJECT_ID ?? '';
  const storageBucket = process.env.EXPO_PUBLIC_FIREBASE_WEB_STORAGE_BUCKET ?? '';
  const messagingSenderId = process.env.EXPO_PUBLIC_FIREBASE_WEB_MESSAGING_SENDER_ID ?? '';
  const appId = process.env.EXPO_PUBLIC_FIREBASE_WEB_APP_ID ?? '';
  const vapidKey = process.env.EXPO_PUBLIC_FIREBASE_WEB_VAPID_KEY ?? '';
  const measurementId = process.env.EXPO_PUBLIC_FIREBASE_WEB_MEASUREMENT_ID;

  if (!apiKey || !authDomain || !projectId || !storageBucket || !messagingSenderId || !appId || !vapidKey) {
    return null;
  }
  return {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId: measurementId || undefined,
    vapidKey,
  };
}
